<template>
    <div class="calendar-task">
        <b-modal size="lg" v-model="showModal" centered hide-footer class="modal-gg">
            <template slot="modal-header" v-if="event && event.data">
                <h3 class="modal-title" v-if="_has(event, 'start')">
                    <small>{{ event.start.format('dddd') }}</small>
                    {{ event.start.date() }}
                    <div class="subtitle">
                        {{ _get(scheduleDate, 'title') }}
                    </div>
                </h3>
                <div class="modal-buttons d-flex align-items-end">
                    <button type="button" data-dismiss="modal" aria-label="Close" @click.prevent="showModal = false">
                        <span aria-hidden="true"><i class="fal fa-fw fa-times"></i></span>
                    </button>
                </div>
            </template>
            <table class="table table-a w-100" v-if="event && event.data">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Dates</th>
                        <th>People</th>
                        <th></th>
                    </tr>
                </thead>
                <tr v-for="reminder in event.data">
                    <td>
                        {{ reminder.name }}
                    </td>
                    <td>
                        <div class="nowrap">
                            <strong>Due Date:</strong>
                            {{ _dateTimeString(reminder.due_at, 'datetime', true, true) }}
                        </div>
                        <div class="nowrap">
                            <strong>Remind At:</strong>
                            {{ _dateTimeString(reminder.remind_at, 'datetime', true, true) }}
                        </div>
                    </td>
                    <td>
                        <div v-for="email in _get(reminder, 'reminds', [])">
                            {{ email }}
                        </div>
                    </td>
                    <td>
                        <button class="btn btn-plain text-danger" @click.prevent="deleteReminder(reminder)">
                            <small>DELETE</small>
                        </button>
                    </td>
                </tr>
            </table>
        </b-modal>
        <portal to="tasksModal">
            <template slot-scope="{ event }">
                <button class="btn btn-plain" title="View Reminders">
                    <span @click.prevent="openModal(event)" class="fa-stack reminder-button text-danger" style="font-size: 13px;">
                        <i class="fal fa-circle fa-stack-2x"></i>
                        <i class="fal fa-megaphone fa-stack-1x"></i>
                    </span>
                </button>
            </template>
        </portal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            event: null,
            showModal: false,
        };
    },
    methods: {
        openModal(event) {
            this.event = event;
            this.showModal = true;
        },
        deleteReminder(reminder) {
            const _this = this;
            axios.delete(`/api/tasks/${reminder.id}`).then(() => {
                _this.showModal = false;
                Bus.$emit('allCalendarsRefetch');
            });
        },
    },
    computed: {
        scheduleDate() {
            return this.$store.getters['calendars/getScheduleDate']({
                calendar: 'fullCalendar',
                date: this.event.start,
            });
        },
    },
};
</script>
